import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import SubMenuIndexes from 'modules/layoutModule/enums/SubMenuIndexes';
import MenuIndexes from 'modules/layoutModule/enums/MenuIndexes';
import {
  contentSettingsModulesList,
  ModulesDefinition,
  newsModulesList,
  NewsSubModuleDefinition,
  settingsModulesList
} from "enums/modulesDefinition";

const { SubMenu } = Menu;

export const NewsMenuTab = (
  subMenuClick: any,
  setSelectedMenu: any,
  subModulesData: any,
  title: string,
  userModules: any[]
) => {
  const renderSubModules = (el: any) => {
    switch (el.id) {
      case NewsSubModuleDefinition.addNews:
        return (
          <Menu.Item
            key={MenuIndexes.NEWS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/news/add">{el.title}</Link>
          </Menu.Item>
        );
      case NewsSubModuleDefinition.showNews:
        return (
          <Menu.Item
            key={MenuIndexes.NEWS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/news">{el.title}</Link>
          </Menu.Item>
        );
      case NewsSubModuleDefinition.fieldNews:
        return (
          <Menu.Item
            key={MenuIndexes.FIELD_NEWS}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/field-news">{el.title}</Link>
          </Menu.Item>
        );
      case NewsSubModuleDefinition.addFieldNews:
        return (
          <Menu.Item
            key={MenuIndexes.FIELD_NEWS_ADD}
            onClick={(e) => setSelectedMenu([e.key])}
          >
            <Link to="/field-news/add">{el.title}</Link>
          </Menu.Item>
        );
      default:
        return null;
    }
  };

  const checkPermissions = newsModulesList.filter((module) => {
    if (userModules.includes(module.id)) return module;
  });

  if (checkPermissions.length === 0) {
    return <></>;
  }

  return (
    <SubMenu
      key={SubMenuIndexes.NEWS}
      icon={<NotificationOutlined />}
      title={title}
      onTitleClick={(e) => subMenuClick(e)}
    >
      {checkPermissions.map((module) => renderSubModules(module))}
    </SubMenu>
  );
};
